import React, { Component } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';

import {
  PUBLISHED,
  DRAFT,
  NEWS,
  ANNOUNCEMENT,
  FAQS,
  TERMS,
  PRIVACY_POLICY,
  upsertPost,
  handleInputChange,
  getPost,
  getTerms,
  getPrivacyPolicy,
  getFAQs,
  resetPost,
  EDITOR_PREFIX
} from '../../store/actions/posts/postsActions';
import {
  uploadImages, ConfirmDialog
} from '../../common/Utilities'

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../../css/posts.css"

import ProgressingButton from "../../common/ProgressingButton"
import { setIsSaving, togglePrompt } from '../../store/actions/commonActions';

class UpsertPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
    this.pathname = this.props.location.pathname;
  }
  
  componentDidMount() {
    this.isReady = false;
    this.isDisabled = false;

    if (this.pathname === '/posts/edit') {
      const urlParams = new URLSearchParams(this.props.location.search);
      const postId =  urlParams.get('id');
      this.props.getPost(postId);
    }if (this.pathname === '/posts/view') {
      const urlParams = new URLSearchParams(this.props.location.search);
      const postId =  urlParams.get('id');
      this.props.getPost(postId);
      this.isDisabled = true;
      //load terms
    } else if (this.pathname === '/terms/edit') {
      this.props.getTerms();
      this.page = TERMS
      this.pageName = "Terms and Conditions"
      //load privacy
    } else if (this.pathname === '/privacy-policy/edit') {
      this.props.getPrivacyPolicy();
      this.page = PRIVACY_POLICY
      this.pageName = "Privacy Policy"
      //load FAQ's
    } else if (this.pathname === '/faqs/edit') {
      this.props.getFAQs();
      this.page = FAQS
      this.pageName = "FAQ's"
    } else {
      this.props.resetPost();
      this.isReady = true;
    }
  }

  componentWillUnmount() {
    this.props.resetPost();
  }

  uploadImageCallBack = (file) => {

    return uploadImages(file)
      .then(imageURL => {
        return {data: {link: imageURL}}
      })
      .catch(e => {console.log(e)})
  }

  renderPostTypeSelect = (post) => {
    let postTypes = [
      // {value: NEWS, label:'News'},
      {value: ANNOUNCEMENT, label:'Announcement'},
    ]
    let postType = post?.post_type ? postTypes.filter(type => type.value === post?.post_type?.id) : postTypes[0];

    if (this.page) {
      postTypes = [{value: this.page, label:this.pageName},]
      postType = postTypes[0]
    }

    return (
      <Select 
        className="post-type" 
        size="xl"
        isDisabled={this.props.common.isSaving || this.isDisabled}
        onChange={(selectedOption) => {
          this.props.handleInputChange(null, {
            post_type: {id: selectedOption.value}
          });
        }}
        options={postTypes}
        defaultValue={postType}
      />
    )
  }

  renderStatusSelect = (post) => {
    const postStatuses = [
      {value: DRAFT, label:'Draft' },
      {value: PUBLISHED, label:'Published' },
    ]
    const status = post?.status?.id ? postStatuses.filter(status => status.value === post?.status?.id) : postStatuses[0];

    return (
      <Select 
        className="status"
        size="xl"
        isDisabled={this.props.common.isSaving || this.isDisabled}
        onChange={(selectedOption) => {

          if (selectedOption.value === 'published') {
            this.showTooltip = true;
          }
          
          this.props.handleInputChange(null, {
            status: {id: selectedOption.value} 
          });
        }}
        options={postStatuses}
        defaultValue={status}
      />
    )
  }

  renderEditor = (post) => {
    return (
      <Editor
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor post-editor"
        toolbarClassName="post-toolbar"
        toolbar={{
          inline: { inDropdown: false },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
          image: { uploadCallback: this.uploadImageCallBack, 
                    previewImage: true,
                    alt: { present: true, mandatory: false } },
          options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'image', 'remove', 'history']
        }}
        onEditorStateChange={this.onEditorStateChange}
        defaultEditorState={this.getDefaultEditorState(post)}
        readOnly={this.props.common.isSaving || this.isDisabled}
      />
    )
  }

  onEditorStateChange = (editorState) => {
    if (editorState) {
      this.setState({
        editorState,
      });
    }
  };

  saveEditorState = () => {
    const editorState = this?.state?.editorState;
    if (editorState) {
      const html = draftToHtml(convertToRaw(editorState.getCurrentContent())).replace(EDITOR_PREFIX,'')
      if (html) {
        this.props.handleInputChange(null, {
          description: html 
        });
      }
    }
  }

  getDefaultEditorState = (post) => {

    //fix for https://github.com/jpuri/react-draft-wysiwyg/issues/609
    const description = post?.description?.startsWith('<p>') ? post?.description : '<p>' + (post?.description || '') + '</p>'
    return description ? EditorState.createWithContent(
      ContentState.createFromBlockArray(
        htmlToDraft(description)
      )
    ) : EditorState.createEmpty()
  }

  render() {

    const post = this.props.posts.post;
    const title = post?.title ?? '';

    if (!this.isReady && post.id) {
      this.isReady = true;
    }

    const hideModal = () => {
      this.props.togglePrompt(false);
    }

    const modalTitle = "Agreement Reset Warning"
    const modalBody = `Publishing this document will show the Terms and Conditions page
      to all users again when they visit the app. Do you still wish to save the document?`

    return this.isReady ? (
      <Row className="post-form" key={post?.id}>
        <ConfirmDialog
          show={this.props.common.togglePrompt} 
          modalTitle={modalTitle}
          modalBody={modalBody}
          onHideFunction={hideModal}
          onClickCancel={hideModal}
          onClickConfirm={()=>{ 
            hideModal();
            this.props.upsertPost();
          }}
        />
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <input 
            className="post-title" 
            type="text" 
            placeholder="Title"
            value={title}
            readOnly={this.props.common.isSaving || this.isDisabled}
            onChange={(e) => {
              this.props.handleInputChange(null, {
                title: e.target.value 
              });
            }}
          />
          <div className="post-div">
            {this.renderPostTypeSelect(post)}
            {this.renderStatusSelect(post)}
            <ProgressingButton
              className="save-button"
              type="submit"
              variant="primary"
              disabled={!this.state.editorState || this.isDisabled}
              onClick={() => {
                this.saveEditorState();
                const showModal = this.page && post?.status?.id === PUBLISHED && post?.post_type?.id !== FAQS
                if (showModal) {
                  this.props.togglePrompt(true);
                } else {
                  this.props.upsertPost()
                }
              }}
              buttonValue="Save" />
          </div>
          <div>
            Note: The first image added will be the hero image for the post. Maximum height of image: 200px, and the image will be resized to cover the width of the post.  
          </div>
          {this.renderEditor(post)}
        </Col>
      </Row>
    ) : <Spinner animation="border" size="sm" />
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
  posts: state.posts
})

const mapDispatchToProps = (dispatch) => {
  return {
    getPost: (...args) => dispatch(getPost(...args)),
    getTerms: (...args) => dispatch(getTerms(...args)),
    getPrivacyPolicy: (...args) => dispatch(getPrivacyPolicy(...args)),
    getFAQs: (...args) => dispatch(getFAQs(...args)),
    resetPost: (...args) => dispatch(resetPost(...args)),
    upsertPost: (...args) => dispatch(upsertPost(...args)),
    handleInputChange: (...args) => dispatch(handleInputChange(...args)),
    setIsSaving: (...args) => dispatch(setIsSaving(...args)),
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpsertPost))
